<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="services__background module__background"
        ></app-modulebackground>
        <div
            class="services__container module__container"
            v-bind:class="{ container__boxed: [1, 2, 3, 4, 5, 6].includes(module.layout.type) }"
        >
            <div class="services__inner module__inner">
                <div class="services__inner--main module__inner--main">
                    <div
                        class="services__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="services__inner-col module__inner-col">
                            <div class="services__header module__header">
                                <h2
                                    class="services__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="services__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="services__inner-row module__inner-row">
                        <div class="services__inner-col module__inner-col">
                            <div class="services__content-block module__content-block">
                                <div
                                    class="services__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 5, 6].includes(
                                            module.layout.type
                                        ),
                                        'col__width--half': [3, 4].includes(module.layout.type)
                                    }"
                                    v-if="
                                        module.data.text ||
                                            ([3, 4].includes(module.layout.type) &&
                                                ((module.data.link && module.data.link.active) ||
                                                    (module.data.link2 &&
                                                        module.data.link2.active) ||
                                                    (module.data.link3 &&
                                                        module.data.link3.active)))
                                    "
                                >
                                    <div
                                        class="services__inner-row module__inner-row"
                                        v-if="module.data.text"
                                    >
                                        <div class="services__inner-col module__inner-col">
                                            <div
                                                class="services__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                    <div
                                        class="services__inner-row module__inner-row"
                                        v-if="
                                            [3, 4].includes(module.layout.type) &&
                                                ((module.data.link && module.data.link.active) ||
                                                    (module.data.link2 &&
                                                        module.data.link2.active) ||
                                                    (module.data.link3 && module.data.link3.active))
                                        "
                                    >
                                        <div class="services__inner-col module__inner-col">
                                            <div class="services__cta module__cta">
                                                <app-modulebutton
                                                    v-if="[3, 4].includes(module.layout.type)"
                                                    :data="module.data.link"
                                                    :custom-class="
                                                        'services__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                                <app-modulebutton
                                                    v-if="[3, 4].includes(module.layout.type)"
                                                    :data="module.data.link2"
                                                    :custom-class="
                                                        'services__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                                <app-modulebutton
                                                    v-if="[3, 4].includes(module.layout.type)"
                                                    :data="module.data.link3"
                                                    :custom-class="
                                                        'services__cta-btn module__cta-btn font-button color-button bg-color-button'
                                                    "
                                                ></app-modulebutton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="services__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 5, 6].includes(
                                            module.layout.type
                                        ),
                                        'col__width--half': [3, 4].includes(module.layout.type)
                                    }"
                                    v-if="items && Array.isArray(items) && items.length > 0"
                                >
                                    <div class="services__inner-row module__inner-row">
                                        <div class="services__inner-col module__inner-col">
                                            <template>
                                                <ul class="services__list module__list">
                                                    <li
                                                        class="services__list-item module__list-item"
                                                        v-bind:class="{
                                                            'col__width--one-fifth': [
                                                                1,
                                                                2
                                                            ].includes(module.layout.type),
                                                            'col__width--full': [3, 4].includes(
                                                                module.layout.type
                                                            ),
                                                            'col__width--one-quarter': [
                                                                5,
                                                                6
                                                            ].includes(module.layout.type)
                                                        }"
                                                        v-for="items__value in items"
                                                        v-bind:key="items__value.id"
                                                        :data-preset-id="items__value.preset_id"
                                                    >
                                                        <div
                                                            class="services__teaser-box"
                                                            v-bind:class="{
                                                                'module__teaser-box--horizontal': [
                                                                    1,
                                                                    2,
                                                                    5,
                                                                    6
                                                                ].includes(module.layout.type),
                                                                'module__teaser-box--vertical': [
                                                                    3,
                                                                    4
                                                                ].includes(module.layout.type)
                                                            }"
                                                        >
                                                            <app-moduleimage
                                                                v-if="
                                                                    items__value.data &&
                                                                        items__value.data.image &&
                                                                        [5, 6].includes(
                                                                            module.layout.type
                                                                        )
                                                                "
                                                                :data="items__value.data.image"
                                                                :tag="'img'"
                                                                :custom-class="
                                                                    'services__teasers-image module__image'
                                                                "
                                                            ></app-moduleimage>
                                                            <div
                                                                v-if="
                                                                    items__value.data &&
                                                                        !items__value.data.image &&
                                                                        [5, 6].includes(
                                                                            module.layout.type
                                                                        )
                                                                "
                                                                class="image-container image-container--img services__teasers-image module__image"
                                                            >
                                                                <img
                                                                    v-bind:src="
                                                                        module.appearance.color == 1
                                                                            ? generateMediaUrl({
                                                                                  path:
                                                                                      'media/images/services/default/2.jpg'
                                                                              })
                                                                            : generateMediaUrl({
                                                                                  path:
                                                                                      'media/images/services/default/1.jpg'
                                                                              })
                                                                    "
                                                                    alt=""
                                                                />
                                                            </div>
                                                            <app-moduleicon
                                                                v-if="
                                                                    [1, 2, 3, 4].includes(
                                                                        module.layout.type
                                                                    )
                                                                "
                                                                :data="
                                                                    (items__value.data &&
                                                                        items__value.data.icon) || {
                                                                        id: getRandomImageInNamespace(
                                                                            'icons/services/default'
                                                                        )
                                                                    }
                                                                "
                                                                :custom-class="
                                                                    'services__teasers-icon module__icon'
                                                                "
                                                            ></app-moduleicon>
                                                            <span
                                                                v-if="
                                                                    items__value.data &&
                                                                        items__value.data.name
                                                                "
                                                                class="services__teasers-label module__teaser-box-text module__label font-bold"
                                                                >{{ items__value.data.name }}</span
                                                            >
                                                        </div>
                                                    </li>
                                                </ul>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="services__inner-row module__inner-row"
                        v-if="
                            [1, 2, 5, 6].includes(module.layout.type) &&
                                ((module.data.link && module.data.link.active) ||
                                    (module.data.link2 && module.data.link2.active) ||
                                    (module.data.link3 && module.data.link3.active))
                        "
                    >
                        <div class="services__inner-col module__inner-col">
                            <div class="services__cta module__cta">
                                <app-modulebutton
                                    v-if="[1, 2, 5, 6].includes(module.layout.type)"
                                    :data="module.data.link"
                                    :custom-class="
                                        'services__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    v-if="[1, 2, 5, 6].includes(module.layout.type)"
                                    :data="module.data.link2"
                                    :custom-class="
                                        'services__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    v-if="[1, 2, 5, 6].includes(module.layout.type)"
                                    :data="module.data.link3"
                                    :custom-class="
                                        'services__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleIcon from '@/components/assorted/ModuleIcon';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';

export default {
    data() {
        return {};
    },
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleicon': ModuleIcon,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['getListItems', 'generateMediaUrl', 'getRandomImageInNamespace']),
        items() {
            return this.getListItems('deha.user.misc.services');
        }
    },
    props: {
        module: Object
    },
    mounted() {}
};
</script>
